import { useQuery } from '@hooks/reactQuery';

import { getAlarmsOran } from '@api/alarmManagement';

import { extractQueryParams } from '@utils/common';

import { IAlarmOran } from '@interfaces/alarms/alarm';
import { IAlarmByVendor } from '@interfaces/alarms/dto/alarmsDTO';

import { EVendorsValues } from '@enums/common';

import { ALARM_LIST_ORAN } from '@constants/queryKeys';

interface IUseQueryAlarmsListOranReturn {
	isLoading: boolean;
	data: IAlarmOran[];
	countOfRecords: number;
}

export const useQueryAlarmsListOran = (
	params: IAlarmByVendor,
): IUseQueryAlarmsListOranReturn => {
	const isEnabled = params.vendor === EVendorsValues.oran;

	const {
		data,
		isInitialLoading: isLoadingAlarmsOran,
	} = useQuery({
		queryKey: [ALARM_LIST_ORAN, params],
		queryFn: extractQueryParams(getAlarmsOran),
		enabled: [isEnabled],
		refetchOnWindowFocus: false,
	});

	return {
		isLoading: isLoadingAlarmsOran,
		data: data?.items || [],
		countOfRecords: data?.count || 0,
	};
};
